import { render, staticRenderFns } from "./SearchTabs.vue?vue&type=template&id=24e8b5e9"
import script from "./SearchTabs.vue?vue&type=script&lang=js"
export * from "./SearchTabs.vue?vue&type=script&lang=js"
import style0 from "./SearchTabs.vue?vue&type=style&index=0&id=24e8b5e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports